<template>
  <div>
  <div  class="row">
    <!--        Primary Insurance-->
      <div class="col-md-10 col-md-offset-1">

        <div class="form-group">
          <small
          >{{computeCaption(fields_en['if_your_insurance_is_not_available_in_the_list_please_select_other'], $store.state.lang.value.toLowerCase())}}
          </small
          >
        </div>
      </div>

      <div class="col-md-10 col-md-offset-1" v-if="this.$store.state.dependentSelected">
        <el-checkbox v-model="checked">{{computeCaption(fields_en['same_insurance_as_main_user'], this.$store.state.lang.value.toLowerCase())}}</el-checkbox>
      </div>
    </div>
    <form @submit.prevent="triggerNextTab">
      <div class="row">
        <div class="col-md-5 col-md-offset-1">
          <div class="form-group">
            <label class="control-label required">
              {{computeReportableCaption('primary_insurance', this.fields_en['primary_insurance_name'], this.$store.state.lang.value.toLowerCase())}}
            </label>
            <el-select
              filterable
              type="text"
              size="large"
              popper-class="select-small-options"
              data-vv-as="Primary Insurance Name"
              v-validate="modelValidations.primary_insurance"
              name="primary_insurance"
              placeholder="ex: Aetna"
              v-model="model.primary_insurance"
              :disabled="checked === true && $store.state.patientRegistrationData['primary_insurance'] !== ''"
            >
              <el-option
                v-for="option in this.$store.state.insurance"
                class="select-danger"
                :value="option.name"
                :label="'* ' + option.name"
                :key="option.name"
              >
              </el-option>
            </el-select>
            <div class="default-grey font-small" v-show="getFieldDescription('insurance_name')" v-html="getFieldDescription('insurance_name') || ''"></div>
            <small class="text-danger" v-show="primary_insurance.invalid">
              {{computeCaption(getError("primary_insurance"), $store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>
        <!--policy number-->
        <div class="col-md-5">
          <div class="form-group">
            <label class="control-label required">
              {{computeReportableCaption('policy_number', this.fields_en['policy_number'], this.$store.state.lang.value.toLowerCase())}}
            </label>
            <input
              class="form-control"
              type="text"
              data-vv-as="Policy Number"
              name="policy_number"
              v-validate="modelValidations.policy_number"
              v-model="model.policy_number"
              placeholder='ex: 123456789'
              :disabled="checked === true && $store.state.patientRegistrationData['policy_number'] !== ''"
              onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
            />
            <div class="default-grey font-small" v-show="getFieldDescription('policy_number')" v-html="getFieldDescription('policy_number') || ''"></div>
            <small class="text-danger" v-show="policy_number.invalid">
              {{computeCaption(getError('policy_number'), $store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>

        <!-- Insurance Name Input -->
        <div class="col-md-10 col-md-offset-1" v-if="this.model.primary_insurance === 'Other'">
          <div class="form-group">
            <label class="control-label required">
              {{computeCaption(fields_en['primary_insurance_name_input'], $store.state.lang.value.toLowerCase())}}
            </label>
            <input class="form-control"
                   type="text"
                   data-vv-as="Primary Insurance Name"
                   name="primary_insurance_name_input"
                   v-validate="modelValidations.primary_insurance_name_input"
                   v-model="model.primary_insurance_name_input"
                   placeholder='ex: Hospital'
                   :disabled="checked === true"
                   onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
            />
            <small class="text-danger" v-show="primary_insurance_name_input.invalid">
              {{computeCaption(getError('primary_insurance_name_input'), $store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>
      </div>

      <div class="row">
        <!--Group Number -->
        <div class="col-md-5 col-md-offset-1">
          <div class="form-group">
            <label class="control-label">
              {{computeReportableCaption('group_number', this.fields_en['group_number'], this.$store.state.lang.value.toLowerCase())}}
            </label>
            <input
              class="form-control"
              type="text"
              data-vv-as="Group Number"
              name="group_number"
              v-validate="modelValidations.group_number"
              v-model="model.group_number"
              placeholder="ex: 123456789"
              :disabled="checked === true && $store.state.patientRegistrationData['group_number'] !== ''"
              onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
            />
            <div class="default-grey font-small" v-show="getFieldDescription('group_number')" v-html="getFieldDescription('group_number') || ''"></div>
            <small class="text-danger" v-show="group_number.invalid">
              {{computeCaption(getError("group_number"), $store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>

        <!--Relationship to Patient:-->
        <div class="col-md-5 form-group">
          <label class="control-label required">
            {{computeCaption(fields_en['patient_relationship_to_insured'], $store.state.lang.value.toLowerCase())}}
          </label
          ><br />
          <el-select
            size="large"
            data-vv-as="Relationship"
            v-validate="modelValidations.relationship"
            placeholder="Single Select"
            name="relationship"
            v-model="model.relationship"
          >
            <el-option
              v-for="option in relationshipList"
              class="select-danger"
              :value="option.value"
              :label="computeCaption(option.label, $store.state.lang.value.toLowerCase())"
              :key="option.label"
            >
            </el-option>
          </el-select>
          <small class="text-danger" v-show="relationship.invalid">
            {{computeCaption(getError("relationship"), $store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
      <input type="submit" value="Submit" hidden />
    </form>

    <div class="row" v-show="!(this.model.relationship === 'Self' && this.hide_self_completed_fields)">
    <div class="col-md-10 col-md-offset-1">
      <el-row :gutter="15">
        <el-col :span="checkMediaScreenWidth() ? 24 : (this.$store.state.requirements['insured_middle_name'] ? 8 : 12)">
          <label class="required">
            {{computeReportableCaption('insured_first_name', this.fields_en['insured_first_name'], this.$store.state.lang.value.toLowerCase())}}
            </label><br>
          <el-input id="firstName"
                    size="small"
                    name="insured_first_name"
                    data-vv-as="Insured First Name"
                    v-validate="modelValidations.insured_first_name"
                    v-model="model.insured_first_name"
                    :disabled="this.model.relationship === 'Self' && $store.state.insuranceData['firstName'] !== '' || checked === true && $store.state.patientRegistrationData['insured_first_name'] !== ''"
                    onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }">
          </el-input>
          <div class="default-grey font-small" v-show="getFieldDescription('insured_first_name')" v-html="getFieldDescription('insured_first_name') || ''"></div>
          <small class="text-danger" v-show="insured_first_name.invalid">
            {{computeCaption(getError("insured_first_name"), $store.state.lang.value.toLowerCase())}}
          </small>
        </el-col>

        <el-col :span="checkMediaScreenWidth() ? 24 : 8" v-if="this.$store.state.requirements['insured_middle_name']">
          <label :class="checkRequirement('insured_middle_name') ? 'required' : ''">
            {{computeReportableCaption('insured_middle_name', this.fields_en['insured_middle_name'], this.$store.state.lang.value.toLowerCase())}}
            </label><br>
          <el-input id="middleName"
                    size="small"
                    data-vv-as="Insured Middle Name"
                    name="insured_middle_name"
                    v-validate="modelValidations.insured_middle_name"
                    v-model="model.insured_middle_name"
                    :disabled="(!!$store.state.requirements.middle_name && this.model.relationship === 'Self' && $store.state.insuranceData['middleName'] !== '' || checked === true && $store.state.patientRegistrationData['insured_middle_name'] !== '')"
                    onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }">
          </el-input>
            <div class="default-grey font-small" v-show="getFieldDescription('insured_middle_name')" v-html="getFieldDescription('insured_middle_name') || ''"></div>
          <small class="text-danger" v-show="insured_middle_name.invalid">
            {{computeCaption(getError("insured_middle_name"), $store.state.lang.value.toLowerCase())}}
          </small>
        </el-col>

        <el-col :span="checkMediaScreenWidth() ? 24 : (this.$store.state.requirements['insured_middle_name'] ? 8 : 12)">
          <label class="required">
            {{computeReportableCaption('insured_last_name', this.fields_en['insured_last_name'], this.$store.state.lang.value.toLowerCase())}}
          </label><br>
          <el-input id="lastName"
                    size="small"
                    name="insured_last_name"
                    data-vv-as="Insured Last Name"
                    v-validate="modelValidations.insured_last_name"
                    v-model="model.insured_last_name"
                    :disabled="(this.model.relationship === 'Self' && $store.state.insuranceData['lastName'] !== '' || checked === true && $store.state.patientRegistrationData['insured_last_name'] !== '')"
                  onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
          >
          </el-input>
          <div class="default-grey font-small" v-show="getFieldDescription('insured_last_name')" v-html="getFieldDescription('insured_last_name') || ''"></div>
          <small class="text-danger" v-show="insured_last_name.invalid">
            {{computeCaption(getError("insured_last_name"), $store.state.lang.value.toLowerCase())}}
          </small>
        </el-col>
      </el-row>
    </div>
  </div>
  <br>

    <div class="row" v-show="!(this.model.relationship === 'Self' && this.hide_self_completed_fields)">
      <!--insured date of birth-->
      <div class="col-md-5 col-md-offset-1">
        <DobSection label="Insured Date Of Birth" :field="'insured_date_of_birth'" ref="dobSection" :dateValue="this.insured_dob"
                    @updateDob="updateDob" :yearsProp="dobYears" :restrictDate="true" :disabled="(model.relationship === 'Self' || checked === true) && this.insured_dob !== ''"/>
      </div>

      <!-- insured gender -->
      <div class="col-md-5">
        <div class="form-group">
          <label class="control-label required">
            {{computeReportableCaption('insured_gender', this.fields_en['insured_gender'], this.$store.state.lang.value.toLowerCase())}}
          </label>
          <el-select
            size="large"
            :disabled="
                (this.model.relationship === 'Self' && !!this.$store.state.requirements.gender) ||
                (checked === true && this.model.insured_gender !== '')
            "
            data-vv-as="Insured Gender"
            v-validate="modelValidations.insured_gender"
            placeholder="Single Select"
            name="insured_gender"
            v-model="model.insured_gender"
          >
            <el-option
              v-for="option in $store.state.gender"
              class="select-danger"
              :value="option.name"
              :label="computeCaption(option.name, $store.state.lang.value.toLowerCase())"
              :key="option.name"
            >
            </el-option>
          </el-select>
          <div class="default-grey font-small" v-show="getFieldDescription('insured_gender')" v-html="getFieldDescription('insured_gender') || ''"></div>
          <small class="text-danger" v-show="insured_gender.invalid">
            {{computeCaption(getError("insured_gender"), $store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
    </div>

    <div v-if="this.$store.state.requirements.insured_address">
    <div class="row" v-if="!this.$store.state.dependentSelected" v-show="!(this.model.relationship === 'Self' && this.hide_self_completed_fields)">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <!-- <small>*{{ translatedFields['same_address_as_previous'] }}</small> -->
          <div class="display-inline">
            <p-checkbox
              v-if="hideCheckBox === true"
              v-model="same_address"
              name="same_address"
              v-validate="modelValidations.agreed"
              :disabled="
                  (this.model.relationship === 'Self' &&
                    this.$store.state.dataForInsurance.addressComponents !== '')
              "
            >
              {{computeCaption(fields_en['same_address_as_previous'], $store.state.lang.value.toLowerCase())}}
            </p-checkbox>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-show="!(this.model.relationship === 'Self' && this.hide_self_completed_fields)">
      <div class="col-md-10 col-md-offset-1">
        <Address
          id="insurance"
          :isDisabled="$store.state.requirements.insured_address && (model.relationship === 'Self' || checked === true || this.same_address)"
          :key="insuredAddress"
          @updateAddress="updateAddress"
          @updateAddress2="updateAddress2"
          :same_address2="this.model.insured_address2"
          :componentsInsurance="model.insured_address_components"
          :checkRequired="checkRequirement('insured_address')"
          ref="AddressComponent"
          wizardStep="insurance" />
        <small class="text-danger" v-if="address_error">
          {{address_error && computeCaption(address_error, $store.state.lang.value.toLowerCase())}}
        </small>
      </div>
    </div>
    </div>

    <div
      v-if="required_insurance_ssn
      "
      class="row"
    >
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label
            class="control-label"
            :class="{ required: required_insurance_ssn }"
          >
            {{computeCaption(fields_en['social_security_number'], $store.state.lang.value.toLowerCase())}}
          </label>
          <input
            class="form-control ssn-cleave-format1"
            autocomplete="off"
            type="text"
            data-vv-as="Social Security Number"
            name="social_security_number"
            v-validate="modelValidations.social_security_number"
            v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
            v-model="model.social_security_number"
          />
          <div class="default-grey font-small" v-show="getFieldDescription('social_number')" v-html="getFieldDescription('social_number') || ''"></div>
          <small class="text-danger" v-show="social_security_number.invalid">
            {{computeCaption(getError("social_security_number"), $store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
    </div>
    <div
      v-if="allow_insurance_card"
      class="row text-center"
    >
      <h5 v-html="computeCaption(fields_en['upload_insurance_card'], $store.state.lang.value.toLowerCase())">
      </h5>
      <MultipleInput :caption="computeReportableCaption('insurance_card_image', fields_en['insurance_card'], $store.state.lang.value.toLowerCase())" :partOfSection="true" :allow="allow_insurance_card" :required="required_insurance_card" ref="insuranceCard" @isValidMultipleInput="isValidMultipleInput"></MultipleInput>
    </div>
     <div>
      <small class="text-danger"> {{errorMessage}} </small>
    </div>
  </div>
</template>

<script>
import {Input, Col, Row, Checkbox, RadioButton, RadioGroup} from 'element-ui'
import {TranslationsUtils} from '../../../../../../utils/Translations'
import Address from '../../Sections/Address'
import {AccessionUtils} from '../../../../../../utils/AccessionDetailsProcessing'
import {mapFields} from 'vee-validate'
import {FormatterUtils} from '../../../../../../utils/Formatter'
import MultipleInput from '../../Sections/MultipleInput'
import Cleave from 'cleave.js'
import {SettingsUtils} from '../../../../../../utils/SiteConfigurations'
import {ValidationUtils} from '../../../../../../utils/Validation'
import {LayoutCalculationUtils} from '../../../../../../utils/LayoutCalculation'
import DobSection from '../MultipleUseParts/Date'
import _ from 'lodash'
import axios from 'axios'
import {PatientInfoUtils} from '../../../../../../utils/PatientInfo'

export default {
  components: {
    DobSection,
    [RadioButton.name]: RadioButton,
    [RadioGroup.name]: RadioGroup,
    [Checkbox.name]: Checkbox,
    MultipleInput,
    Address,
    [Col.name]: Col,
    [Row.name]: Row,
    [Input.name]: Input
  },
  props: ['insurancePay', 'allowPayment'],
  mixins: [TranslationsUtils, AccessionUtils, FormatterUtils, SettingsUtils, ValidationUtils, LayoutCalculationUtils, PatientInfoUtils],
  data () {
    return {
      errorMessage: '',
      paymentMethod: '',
      relationshipList: [{value: 'Self', label: 'Self'}, {value: 'Child', label: 'Child'}, {value: 'Parent', label: 'Parent'}, {value: 'Spouse', label: 'Spouse'}],
      errorDate: '',
      hideCheckBox: true,
      insuredAddress: 99,
      same_address: false,
      address_error: '',
      sameAddress: '',
      checked: null,
      dobYears: [],
      insured_dob: '',
      validationObject: {
        relationship: false,
        primary_insurance: false,
        primary_insurance_name_input: false,
        policy_number: false,
        insured_first_name: false,
        insured_middle_name: false,
        insured_last_name: false,
        insured_date_of_birth: false,
        insured_gender: false,
        insured_address: false,
        insured_card_name: false,
        insurance_ssn: false
      },
      model: {
        interface_message_queue_id: '',
        social_security_number: '',
        primary_insurance: '',
        primary_insurance_name_input: '',
        policy_number: '',
        group_number: '',
        relationship: '',
        insured_first_name: '',
        insured_middle_name: '',
        insured_last_name: '',
        insured_date_of_birth: '',
        insured_address_components: {
          name: '',
          original_name: '',
          delivery_line_1: '',
          city_name: '',
          county: '',
          state_abbreviation: '',
          zipcode: '',
          plus4_code: '',
          county_fips: '',
          country: ''
        },
        insured_address2: '',
        insured_gender: '',
        insurance_card_images: [],
        insurance_card_names: [],
        error_uninsured: '',
        note: ''
      },
      modelValidations: {
        primary_insurance: {
          required: true
        },
        primary_insurance_name_input: {
          required: true,
          min: 2
        },
        policy_number: {
          min: 2,
          required: true
        },
        group_number: {
        },
        relationship: {
          required: true
        },
        insured_first_name: {
          required: true
        },
        insured_middle_name: {
          required: this.checkRequirement('insured_middle_name')
        },
        insured_last_name: {
          required: true
        },
        insured_gender: {
          required: true
        },
        insurance_card_image: {
          required: this.checkRequirement('insurance_card_image')
        },
        insured_address: {
          min: 5,
          required: this.checkRequirement('insured_address')
        },
        insured_address2: {},
        social_security_number: {
          min: 11,
          max: 11
        }
      },
      fields_en: {
        same_insurance_as_main_user: 'Same insurance as main user',
        if_your_insurance_is_not_available_in_the_list_please_select_other: '*If your insurance is not available in the list please select Other',
        social_security_number: 'Social Security Number',
        upload_insurance_card: 'Now upload or take a picture <b> of your insurance card</b>',
        insured_address: 'Insured Address',
        insured_address2: 'Insured Address 2',
        insurance: 'Insurance',
        primary_insurance_name: 'Primary Insurance Name',
        primary_insurance_name_input: 'Primary Insurance',
        policy_number: 'Policy Number',
        group_number: 'Group Number',
        patient_relationship_to_insured: 'Patient Relationship to Insured',
        insured_first_name: 'Insured First Name',
        insured_middle_name: 'Insured Middle Name',
        insured_last_name: 'Insured Last Name',
        insured_date_of_birth: 'Insured Date of Birth',
        insured_gender: 'Insured Gender',
        same_address_as_previous: 'Address is the same as previously entered',
        insurance_card: 'Insurance Card'
      }
    }
  },
  beforeMount () {
    const currentYear = new Date().getFullYear()
    for (let i = currentYear; i >= 1900; i--) {
      this.dobYears.push(i)
    }
    this.$emit('validateBill', false)
    if (!this.required_insurance_ssn) {
      this.validationObject.insurance_ssn = true
    } else {
      this.validationObject.insurance_ssn = false
    }
    if (!this.checkRequirement('insured_middle_name')) {
      this.validationObject.insured_middle_name = true
    }
    if (this.allow_insurance_card && !this.required_insurance_card || !this.allow_insurance_card) {
      this.validationObject.insured_card_name = true
    } else {
      this.validationObject.insured_card_name = false
    }
    let token = localStorage.getItem('token')
    if (token) {
      this.model.relationship = this.$store.state.userData['relationship'] || ''
      if (this.$store.state.dependentSelected) {
        this.checked = this.$store.state.userData['insured_same_as'] === '1'
        if (this.checked === false) {
          this.relationshipList = []
          this.relationshipList.push({value: 'Self', label: 'Self'})
        }
        this.model.relationship = this.$store.state.userData['relationship'] || ''
      } else {
        setTimeout(() => {
          this.setUserData()
        }, 300)
      }
    } else {
      if (this.$store.state.insuranceModel) {
        this.model = this.$store.state.insuranceModel
      }
    }
  },
  methods: {
    async validate () {
      let info = await this.getPatientInfo()
      await this.$validator.validateAll()
      if (this.$validator.errors.items.length) {
        document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
        return false
      }
      let dobValidation = await this.$refs.dobSection.validate()
      if (dobValidation === false) {
        return false
      }
      if (this.$store.state.required_insurance_ssn && !this.model.social_security_number) {
        this.$validator.errors.add({field: 'social_security_number', msg: 'Social Security Number field is required'})
        let field = this.$validator._resolveField('social_security_number')
        field.setFlags({invalid: true})
        document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
        return false
      }
      if (this.checkRequirement('insured_address')) {
        this.address_error = ''
        let addressValidation = this.$refs.AddressComponent.validate()
        if (!addressValidation) {
          this.address_error = 'All the required fields must be completed!'
          return false
        }
      }
      // call insurance card images validation
      if (this.allow_insurance_card) {
        let insuranceCardArr = await this.$refs.insuranceCard.validate()
        if (insuranceCardArr !== false && insuranceCardArr !== undefined && insuranceCardArr.length > 0) {
          this.model.insurance_card_images = insuranceCardArr[0]
          this.model.insurance_card_names = insuranceCardArr[1]
        } else {
          if (this.required_insurance_card) {
            return false
          }
        }
      }
      if (this.model.primary_insurance === 'Other' && this.model.primary_insurance_name_input !== '' && this.model.policy_number !== '' && !this.model.policy_number.includes('-') && this.$validator.errors.items.length === 0) {
        this.model.policy_number = this.model.primary_insurance_name_input + ' - ' + this.model.policy_number
      }
      if (_.get(this.$store.state.configs, 'VALIDATE_INSURANCE_WITH_API', null)) {
        // build object for api call, if api call is true, reset error, else return false with error message
        let insuredData = {
          'insurance_name': this.model.primary_insurance,
          'first_name': this.model.insured_first_name,
          // 'middle_name': '',
          'middle_name': this.model.insured_middle_name,
          'last_name': this.model.insured_last_name,
          'date_of_birth': this.model.insured_date_of_birth,
          'policy_number': this.model.policy_number,
          'info': info
        }
        let scopeValidation = true
        await axios.post(process.env.SERVER_URI + '/check/insurance', insuredData)
          .then((response) => {
            this.model.interface_message_queue_id = response['data']['data']['interface_message_queue_id']
            if (response['data']['data']['success'] === false) {
              this.errorMessage = this.computeCaption('Insurance is invalid, please take a closer look at the completed fields and retry', this.$store.state.lang)
              scopeValidation = false
            } else if (response['data']['data']['eligible'] === true) {
              this.errorMessage = ''
            } else {
              scopeValidation = false
              this.errorMessage = this.computeCaption('Insurance is invalid, please take a closer look at the completed fields and retry', this.$store.state.lang)
            }
          })
        if (scopeValidation !== true) {
          this.$store.state.insuranceValidator = false
          return false
        }
      }
      return true
    },
    setUserData () {
      if (this.model.relationship !== 'Self') {
        this.insured_dob = this.$store.state.userData['insured_date_of_birth'] || ''
        this.model.insured_first_name = this.$store.state.userData['insured_first_name'] || ''
        this.model.insured_middle_name = this.$store.state.userData['insured_middle_name'] || ''
        this.model.insured_last_name = this.$store.state.userData['insured_last_name'] || ''
        this.model.insured_address = this.$store.state.userData['insured_address'] || ''
        this.model.insured_address2 = this.$store.state.userData['insured_address2'] || ''
        this.model.insured_gender = this.$store.state.userData['insured_gender'] || ''
        this.model.insured_address_components = this.$store.state.userData['insured_address_components'] || this.resetAddressObject()
        this.updateAddress(this.model.insured_address_components)
      }
      this.model.primary_insurance = this.$store.state.userData['primary_insurance']
      this.model.group_number = this.$store.state.userData['group_number'] || ''
      if (this.$store.state.userData['primary_insurance'] === 'Other') {
        this.model.primary_insurance_name_input = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', false)
        this.model.policy_number = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', true)
      } else {
        this.model.primary_insurance_name_input = ''
        this.model.policy_number = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', true)
      }
    },
    getPolicyOrInsurance (policyNumber, policyBoolean) {
      if (policyBoolean) {
        policyNumber = (policyNumber.indexOf('-') !== -1) ? policyNumber.slice(policyNumber.indexOf('-') + 2) : policyNumber
        return policyNumber
      } else {
        let insuranceName = policyNumber.slice(0, policyNumber.indexOf('-') - 1)
        return insuranceName
      }
    },
    triggerNextTab () {
      this.$emit('triggerNextTab')
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    updateAddress (data) {
      this.model.insured_address_components = data
      this.address_error = ''
    },
    updateAddress2 (data) {
      this.model.insured_address2 = data
    },
    isValidMultipleInput (valid) {
      if (valid) {
        this.validationObject.insured_card_name = true
      } else {
        this.validationObject.insured_card_name = false
      }
    },
    validateAddress (objectAddress, excludedValues) {
      let flag = true
      for (let iterator in objectAddress) {
        if (!excludedValues.includes(iterator)) {
          if (objectAddress[iterator] === '') {
            flag = false
          }
        }
      }
      if (flag) {
        return true
      }
      return false
    },
    resetAddressObject () {
      let resetAddress = {
        name: '',
        original_name: '',
        delivery_line_1: '',
        city_name: '',
        county: '',
        state_abbreviation: '',
        zipcode: '',
        plus4_code: '',
        county_fips: '',
        country: ''
      }
      return resetAddress
    },
    isEmptyObject (objectValue) {
      if (objectValue === undefined || null) {
        return true
      }
      if (Object.keys(objectValue).length > 0) {
        return false
      } else {
        return true
      }
    },
    updateDob (dobObject) {
      this.model.insured_date_of_birth = dobObject.composedDate
    }
  },
  computed: {
    hide_self_completed_fields () {
      return this.$store.state.configs.HIDE_SELF_COMPLETED_FIELDS
    },
    allow_insurance_card () {
      return this.$store.state.requirements.insurance_card_image
    },
    required_insurance_card () {
      return this.checkRequirement('insurance_card_image')
    },
    required_insurance_ssn () {
      return this.isTrue(this.$store.state.required_insurance_ssn)
    },
    ...mapFields(['primary_insurance', 'primary_insurance_name_input', 'policy_number', 'group_number', 'relationship', 'insurance_pay', 'insured_first_name', 'insured_middle_name', 'insured_last_name', 'insured_date_of_birth', 'insured_gender', 'insured_address', 'insured_address2', 'social_security_number'])
  },
  watch: {
    'validationObject': {
      handler (before, after) {
        if (Object.values(this.validationObject).every(field => field === true)) {
          this.$emit('validateBill', true)
        } else {
          this.$emit('validateBill', false)
        }
      },
      deep: true
    },
    'model': {
      handler: function (value) {
        this.$store.state.insuranceModel = value
        this.$emit('updateModel', this.model)
      },
      deep: true
    },
    'model.insured_first_name': {
      handler: function (value) {
        if (this.model.insured_first_name) {
          this.validationObject.insured_first_name = true
        } else {
          this.validationObject.insured_first_name = false
        }
      }
    },
    'model.insured_middle_name': {
      handler: function (value) {
        if (this.checkRequirement('insured_middle_name')) {
          if (this.model.insured_middle_name) {
            this.validationObject.insured_middle_name = true
          } else {
            this.validationObject.insured_middle_name = false
          }
        } else {
          this.validationObject.insured_middle_name = true
        }
      }
    },
    'model.insured_last_name': {
      handler: function (value) {
        if (this.model.insured_last_name) {
          this.validationObject.insured_last_name = true
        } else {
          this.validationObject.insured_last_name = false
        }
      }
    },
    'model.insured_gender': {
      handler: function (value) {
        if (this.model.insured_gender || this.model.relationship === 'Self' && this.hide_self_completed_fields) {
          this.validationObject.insured_gender = true
        } else {
          this.validationObject.insured_gender = false
        }
      }
    },
    'model.insured_date_of_birth': {
      handler: function (value) {
        if (value !== undefined) {
          if (value.length === 10) {
            this.validationObject.insured_date_of_birth = true
          } else {
            this.validationObject.insured_date_of_birth = false
          }
        }
      }
    },
    'model.relationship': {
      handler: function (after, before) {
        if (!this.checked && this.$store.state.insuranceModel === undefined) {
          this.hideCheckBox = true
          this.model.insured_first_name = ''
          this.model.insured_middle_name = ''
          this.model.insured_last_name = ''
          this.insured_dob = ''
          this.model.insured_gender = ''
          this.model.insured_address_components = this.resetAddressObject()
          this.sameAddress = false
        }
        if (this.model.relationship === 'Self' && this.hide_self_completed_fields) {
          this.validationObject.insured_gender = true
        }
        if (this.checked && this.model.relationship === 'Self') {
          this.model.relationship = ''
        }
        if (this.model.relationship === 'Self' && !this.checked) {
          this.model.insured_first_name = this.$store.state.insuranceData.firstName
          this.model.insured_middle_name = this.$store.state.insuranceData.middleName
          this.model.insured_last_name = this.$store.state.insuranceData.lastName
          this.model.insured_gender = this.$store.state.insuranceData.gender || this.$store.state.userData['insured_gender']
          this.insured_dob = this.$store.state.insuranceData.dob
          this.model.insured_address_components = this.$store.state.insuranceData.addressComponents
          this.sameAddress = this.$store.state.insuranceData.addressComponents
          this.hideCheckBox = false
          this.updateAddress(this.model.insured_address_components)
          this.model.insured_address = this.$store.state.insuranceData.address
          this.model.insured_address2 = this.$store.state.dataForInsurance.address2
          this.insuredAddress += 1
        } else {
          this.hideCheckBox = true
          this.errorDate = 'Insurance Date Of Birth field is required'
        }
        if (this.model.relationship !== 'Self' && !this.checked) {
          this.model.insured_first_name = ''
          this.model.insured_middle_name = ''
          this.model.insured_last_name = ''
          this.insured_dob = ''
          this.model.insured_gender = ''
          this.model.insured_address2 = ''
          this.model.insured_address_components = this.resetAddressObject()
        }
        this.$validator.reset()
        this.errorDate = ''
        if (this.model.relationship) {
          this.validationObject.relationship = true
        } else {
          this.validationObject.relationship = false
        }
      },
      deep: true
    },
    'model.primary_insurance': {
      handler: function (value) {
        if (this.model.primary_insurance) {
          this.validationObject.primary_insurance = true
        } else {
          this.validationObject.primary_insurance = false
        }
        if (value === 'Other' && this.model.primary_insurance_name_input === '') {
          this.validationObject.primary_insurance_name_input = false
        } else {
          this.validationObject.primary_insurance_name_input = true
        }
      }
    },
    'model.primary_insurance_name_input': {
      handler: function (value) {
        if (this.model.primary_insurance === 'Other') {
          if (this.model.primary_insurance_name_input) {
            this.validationObject.primary_insurance_name_input = true
          } else {
            this.validationObject.primary_insurance_name_input = false
          }
        } else {
          this.validationObject.primary_insurance_name_input = true
        }
      }
    },
    'model.policy_number': {
      handler: function (value) {
        if (this.model.policy_number.length >= this.modelValidations.policy_number.min) {
          this.validationObject.policy_number = true
        } else {
          this.validationObject.policy_number = false
        }
      }
    },
    'model.social_security_number': {
      handler: function (after, before) {
        if (this.required_insurance_ssn) {
          if (after.length < this.modelValidations.social_security_number.min) {
            let ssnCleave = new Cleave('.ssn-cleave-format1', {
              delimiters: ['-', '-'],
              numericOnly: true,
              uppercase: true,
              blocks: [3, 2, 4]
            })
            this.model.social_security_number = ssnCleave.getFormattedValue()
          } else if (after.length > this.modelValidations.social_security_number.max) {
            this.model.social_security_number = this.model.social_security_number.substr(0, this.model.social_security_number.length - 1)
          }
          if (after.length === this.modelValidations.social_security_number.min) {
            this.validationObject.insurance_ssn = true
          } else {
            this.validationObject.insurance_ssn = false
          }
        } else {
          this.validationObject.insurance_ssn = true
        }
      },
      deep: true
    },
    'model.insured_address_components': {
      handler: function (value) {
        if (this.checkRequirement('insured_address')) {
          let excludedValues = []
          if (this.$store.state.international) {
            excludedValues = ['name', 'original_name', 'plus4_code', 'zipcode', 'state_abbreviation', 'county_fips']
          } else {
            if (this.force_valid_address) {
              excludedValues = ['name', 'original_name', 'plus4_code']
            } else {
              excludedValues = ['name', 'original_name', 'plus4_code', 'county_fips']
            }
          }
          if (!this.isEmptyObject(this.model.insured_address_components) && this.validateAddress(this.model.insured_address_components, excludedValues)) {
            this.validationObject.insured_address = true
          } else {
            this.validationObject.insured_address = false
          }
        } else {
          this.validationObject.insured_address = true
        }
      },
      deep: true
    },
    '$store.state.insuranceData.addressComponents': {
      handler: function (before, after) {
        if (this.$store.state.configs['SINGLE_PAGE_ORDERS'] === true && (this.model.relationship === 'Self' || this.model.sameAddress === true)) {
          this.model.sameAddress = true
          this.model.insured_address_components = this.$store.state.insuranceData.addressComponents
          this.updateAddress(this.model.insured_address_components)
          this.model.insured_address = this.$store.state.insuranceData.address
          this.insuredAddress += 1
        }
      },
      deep: true
    },
    '$store.state.dataForInsurance.address2': {
      handler: function (before, after) {
        let token = localStorage.getItem('token')
        if ((token || this.$store.state.configs['SINGLE_PAGE_ORDERS'] === true) && (this.model.relationship === 'Self' || this.model.sameAddress === true)) {
          this.model.insured_address2 = this.$store.state.dataForInsurance.address2
        }
      },
      deep: true
    },
    '$store.state.required_insurance_ssn': {
      handler: function (val) {
        if (!this.required_insurance_ssn) {
          this.validationObject.insurance_ssn = true
        } else {
          this.validationObject.insurance_ssn = false
        }
      },
      deep: true
    },
    '$store.state.requirements.insurance_card_image': {
      handler: function (val) {
        if (this.allow_insurance_card && !this.required_insurance_card || !this.allow_insurance_card) {
          this.validationObject.insured_card_name = true
        } else {
          this.validationObject.insured_card_name = false
        }
      },
      deep: true
    },
    '$store.state.requirements.insured_middle_name': {
      handler: function (val) {
        if (this.checkRequirement('insured_middle_name')) {
          if (this.model.insured_middle_name === '') {
            this.validationObject.insured_middle_name = false
          } else {
            this.validationObject.insured_middle_name = true
          }
        } else {
          this.validationObject.insured_middle_name = true
        }
      },
      deep: true
    },
    '$store.state.insuranceData.firstName': {
      handler: function (before, after) {
        if (this.$store.state.configs['SINGLE_PAGE_ORDERS'] === true && this.model.relationship === 'Self') {
          this.model.insured_first_name = this.$store.state.insuranceData.firstName
        }
      }
    },
    '$store.state.insuranceData.middleName': {
      handler: function (before, after) {
        if (this.$store.state.configs['SINGLE_PAGE_ORDERS'] === true && this.model.relationship === 'Self') {
          this.model.insured_middle_name = this.$store.state.insuranceData.middleName
        }
      }
    },
    '$store.state.insuranceData.lastName': {
      handler: function (before, after) {
        if (this.$store.state.configs['SINGLE_PAGE_ORDERS'] === true && this.model.relationship === 'Self') {
          this.model.insured_last_name = this.$store.state.insuranceData.lastName
        }
      }
    },
    '$store.state.insuranceData.dob': {
      handler: function (before, after) {
        if (this.$store.state.configs['SINGLE_PAGE_ORDERS'] === true && this.model.relationship === 'Self') {
          this.insured_dob = this.$store.state.insuranceData.dob
        }
      }
    },
    '$store.state.insuranceData.gender': {
      handler: function (before, after) {
        if (this.$store.state.configs['SINGLE_PAGE_ORDERS'] === true && this.model.relationship === 'Self' && this.$store.state.requirements.gender) {
          this.model.insured_gender = this.$store.state.insuranceData.gender
          this.$store.state.dataForInsurance.gender = this.$store.state.insuranceData.gender
        }
      }
    },
    same_address () {
      if (this.same_address) {
        if (this.$store.state.configs['SINGLE_PAGE_ORDERS'] === false) {
          this.sameAddress = this.$store.state.dataForInsurance.addressComponents
          this.model.insured_address_components = this.$store.state.dataForInsurance.addressComponents || this.resetAddressObject()
          this.model.insured_address2 = this.$store.state.dataForInsurance.address2 || ''
        } else {
          this.model.sameAddress = true
          this.model.insured_address_components = this.$store.state.insuranceData.addressComponents
          this.updateAddress(this.model.insured_address_components)
          this.model.insured_address = this.$store.state.insuranceData.address
          this.model.insured_address2 = this.$store.state.dataForInsurance.address2 || ''
          this.insuredAddress += 1
        }
      } else {
        this.sameAddress = ''
        this.model.insured_address_components = this.resetAddressObject()
        this.model.insured_address2 = ''
        this.insuredAddress += 1
      }
    },
    'checked': {
      handler: function (after, before) {
        if (this.checked === true) {
          this.relationshipList = [{value: 'Child', label: 'Child'}, {value: 'Parent', label: 'Parent'}, {value: 'Spouse', label: 'Spouse'}]
          this.model.relationship = this.$store.state.userData['relationship'] || ''
          if (this.model.relationship === 'Self') {
            this.model.relationship = ''
          }
          this.model.primary_insurance = this.$store.state.patientRegistrationData['primary_insurance'] || ''
          if (this.$store.state.patientRegistrationData['primary_insurance'] === 'Other') {
            this.model.primary_insurance_name_input = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', false)
            this.model.policy_number = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', true)
          } else {
            this.model.primary_insurance_name_input = ''
            this.model.policy_number = this.$store.state.patientRegistrationData['policy_number'] || ''
          }
          this.model.group_number = this.$store.state.patientRegistrationData['group_number'] || ''
          this.model.insured_first_name = this.$store.state.patientRegistrationData['insured_first_name'] || ''
          this.model.insured_middle_name = this.$store.state.patientRegistrationData['insured_middle_name'] || ''
          this.model.insured_last_name = this.$store.state.patientRegistrationData['insured_last_name'] || ''
          this.model.insured_gender = this.$store.state.patientRegistrationData['insured_gender'] || ''
          this.insured_dob = this.$store.state.patientRegistrationData['dob'] || ''
          this.model.insured_address_components = this.$store.state.patientRegistrationData['insured_address_components'] || ''
          this.model.insured_address = this.$store.state.patientRegistrationData['insured_address'] || ''
          this.model.insured_address2 = this.$store.state.patientRegistrationData['insured_address2'] || ''
          this.insuredAddress += 1
          this.updateAddress(this.model.insured_address_components)
        } else if (this.checked === false) {
          this.relationshipList = []
          if (!this.relationshipList.find(element => element.label === 'Self')) {
            this.relationshipList.push({value: 'Self', label: 'Self'})
          }
          this.model.primary_insurance = this.$store.state.userData['primary_insurance'] || ''
          if (this.$store.state.userData['primary_insurance'] === 'Other') {
            this.model.primary_insurance_name_input = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', false)
            this.model.policy_number = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', true)
          } else {
            this.model.primary_insurance_name_input = ''
            this.model.policy_number = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', true)
          }
          this.model.group_number = this.$store.state.userData['group_number'] || ''
          this.model.relationship = 'Self'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/SubComponents/BillParts/Insurance.vue